/**
 * 일본어. 다국어표(`HERIT_UI_다국어.docx`)에 있는 키는 표 그대로.
 * 표에 없는 키는 구현자 번역 — 각 항목에 `// TODO 검수` 표시, 고객 검수 후 확정.
 */
export const COPY_JA = {
    "common.back": "戻る", // TODO 검수
    "common.brandCaption": "韓国の美しさ、私の一枚", // TODO 검수
    "common.home": "最初に戻る",
    "common.keepGoing": "続ける",
    "common.homeConfirmTitle": "最初に戻りますか？",
    "common.homeConfirmBody": "ここまでの内容は消えます。",
    "idle.title": "まだいらっしゃいますか？",
    "idle.body": "{sec}秒間操作がないと最初の画面に戻ります",
    "common.brandTag": "韓国文化フォトブース", // TODO 검수
    "journey.theme": "テーマ選択",
    "journey.style": "スタイル選択",
    "journey.capture": "撮影",
    "journey.result": "結果確認",
    "journey.receive": "受け取り",
    "attract.tagline": "韓国文化 AI フォトブース",
    "attract.headline": "韓国の美しさに\n自分を映す瞬間",
    "attract.cta": "はじめる",
    "themeSelect.title": "テーマをお選びください",
    "themeSelect.count": "{n}種類のテーマ", // TODO 검수
    "themeSelect.cta": "選択する",
    "themeSelect.storiesLabel": "収められた物語",
    "styleSelect.back": "テーマを選び直す", // TODO 검수
    "styleSelect.title": "スタイルを選んでください",
    "styleSelect.cta": "このスタイルで進む",
    "styleSelect.next": "次のスタイルへ", // TODO 검수
    // consent
    "consent.title": "撮影前に\n同意が必要です", // TODO 검수
    "consent.required": "必須", // TODO 검수
    "consent.view": "見る", // TODO 검수
    "consent.close": "閉じる", // TODO 검수
    "consent.allAgree": "すべてに同意する", // TODO 검수
    "consent.processor": "個人情報管理者：{name}", // TODO 검수
    "consent.contact": "お問い合わせ：{contact}", // TODO 검수
    "consent.refusal": "同意なしでは撮影サービスをご利用いただけません", // TODO 검수
    "consent.cta": "同意する", // TODO 검수
    "consent.decline": "同意しない", // TODO 검수
    "consent.back": "スタイル選択へ戻る", // TODO 검수
    "preview.back": "スタイルを選び直す", // TODO 검수
    "preview.title": "カメラを見てください",
    "preview.tip1": "顔がよく見えるように正面を向いてください。", // TODO 검수
    "preview.tip2": "撮影ボタンを押すと{sec}秒後に撮影されます。", // TODO 검수
    "preview.tip3": "気に入らなければ撮り直せます。", // TODO 검수
    "preview.placeholderTitle": "カメラの前に立ってください", // TODO 검수
    "preview.placeholderBody": "カメラに接続しています。\n初回はカメラの使用を許可してください。", // TODO 검수
    "preview.connecting": "カメラ接続中…", // TODO 검수
    "preview.shoot": "撮影する",
    "preview.openCamera": "カメラを起動", // TODO 검수
    "preview.closeCamera": "案内に戻る", // TODO 검수
    "preview.cancel": "撮影をキャンセル", // TODO 검수
    "preview.retry": "カメラに再接続", // TODO 검수
    "preview.note": "撮影した写真はAI変換のみに使用します。", // TODO 검수
    "preview.holdStill": "動かないでください", // TODO 검수
    "preview.confirmTitle": "この写真で進めますか？", // TODO 검수
    "preview.confirmHint": "目をつぶったりぶれていたら撮り直してください。", // TODO 검수
    "preview.confirmRetake": "撮り直す", // TODO 검수
    "preview.confirmProceed": "このまま進む", // TODO 검수
    "preview.errorTitle": "カメラを使用できません", // TODO 검수
    "preview.errorTitleNoDevice": "カメラがありません", // TODO 검수
    "preview.errorPermissionDenied": "カメラの権限がオフです。ブラウザ設定でカメラを許可してから再接続してください。", // TODO 검수
    "preview.errorNoDevice": "この端末で接続されたカメラが見つかりません。カメラを接続してからもう一度お試しください。", // TODO 검수
    "preview.errorInsecureContext": "カメラはHTTPSのアドレスでのみ使用できます。", // TODO 검수
    "preview.errorTimeout": "カメラが応答しません。他のアプリがカメラを使用していないか確認してから再接続してください。", // TODO 검수
    "preview.errorUnknown": "カメラに接続できませんでした。もう一度接続してください。", // TODO 검수
    "generate.title": "写真を生成しています",
    "generate.hint": "約30秒ほどかかります",
    "generate.selectedLabel": "SELECTED STYLE",
    "generate.developing": "DEVELOPING",
    "generate.step0": "顔を確認しています", // TODO 검수
    "generate.step1": "衣装を着せています", // TODO 검수
    "generate.step2": "背景を描いています", // TODO 검수
    "generate.step3": "仕上げの細部を加えています", // TODO 검수
    "generate.remaining": "残り約{sec}秒", // TODO 검수
    "generate.almostDone": "もうすぐ完成です", // TODO 검수
    "generate.queueWait": "順番待ちが長くなっています。少々お待ちください", // TODO 검수
    "generate.tookTooLong": "時間がかかっています", // TODO 검수
    "generate.failed": "変換に失敗しました", // TODO 검수
    "generate.cancel": "キャンセル", // TODO 검수
    "generate.retry": "もう一度試す", // TODO 검수
    "generate.proceed": "そのまま進む", // TODO 검수
    "generate.back": "撮影に戻る", // TODO 검수
    "review.title": "完成しました",
    "review.retake": "撮り直す",
    "review.next": "写真を受け取る",
    "review.makeVideo": "✨ 動画も作る", // TODO 검수
    "review.makeVideoPriced": "✨ 動画も作る · +{price}", // TODO 검수
    "review.slotError": "変換失敗", // TODO 검수
    "videoIntro.back": "結果に戻る", // TODO 검수
    "videoIntro.title": "動くポートレート", // TODO 검수
    "videoIntro.body": "5秒の縦動画。\nスマホに保存してすぐ投稿できます。", // TODO 검수
    "videoIntro.cta": "作る", // TODO 검수
    "videoIntro.skip": "写真だけにする", // TODO 검수
    "videoMotions.back": "結果に戻る", // TODO 검수
    "videoMotions.title": "動きを選んでください", // TODO 검수
    "videoMotions.subtitle": "最大2つ · 選んだ順番につながります", // TODO 검수
    "videoMotions.hint": "動きを1つ以上選んでください", // TODO 검수
    "videoMotions.next": "次へ", // TODO 검수
    "videoCaption.back": "戻る", // TODO 검수
    "videoCaption.title": "ひとこと残しますか？", // TODO 검수
    "videoCaption.subtitle": "動画の中に字幕として入ります", // TODO 검수
    "videoCaption.placeholder": "最大12文字", // TODO 검수
    "videoCaption.preset1": "済州で、今日", // TODO 검수
    "videoCaption.preset2": "風が連れてきた日", // TODO 검수
    "videoCaption.preset3": "ずっと残りますように", // TODO 검수
    "videoCaption.preset4": "いいことだけ", // TODO 검수
    "videoCaption.next": "次へ", // TODO 검수
    "videoCaption.skip": "入れない", // TODO 검수
    "videoGenerate.back": "結果に戻る", // TODO 검수
    "videoGenerate.title": "動画の制作を始めています", // TODO 검수
    "videoGenerate.caption": "少しお待ちください", // TODO 검수
    "videoGenerate.error": "動画の生成に失敗しました", // TODO 검수
    "videoGenerate.retry": "もう一度試す", // TODO 검수
    "videoGenerate.skipToPhoto": "写真だけ受け取る", // TODO 검수
    "videoGenerate.refunded": "動画の料金はお支払い方法に自動で返金されます。", // TODO 검수
    "payment.title": "お支払い", // TODO 검수
    "payment.cancel": "キャンセル", // TODO 검수
    "payment.kicker": "SCAN TO PAY",
    "payment.itemPhoto": "写真プリント 1枚", // TODO 검수
    "payment.itemVideo": "動く一枚 5秒", // TODO 검수
    "payment.total": "合計", // TODO 검수
    "payment.qrHeading": "スマートフォンでお支払いください", // TODO 검수
    "payment.qrHint": "スマートフォンのカメラでQRコードを読み取ってください", // TODO 검수
    "payment.methods": "カカオペイ · ネイバーペイ · トスペイ · カード", // TODO 검수
    "payment.noticeVideo": "お支払いの確認後に動画の制作を開始します。\nお支払い前には制作しません。", // TODO 검수
    "payment.noticePhoto": "お支払いの確認後に写真を受け取れます。", // TODO 검수
    "payment.remaining": "残り {time}", // TODO 검수
    "payment.wifiHint": "モバイルデータが使えない場合は店内Wi-Fiをご利用ください。", // TODO 검수
    "payment.connectionLost": "接続を確認しています。お支払いが完了すると自動的に進みます。", // TODO 검수
    "payment.failedHint": "お支払いが完了しませんでした。スマートフォンでもう一度お試しください。", // TODO 검수
    "payment.unavailable": "現在お支払いをご利用いただけません。\nスタッフをお呼びください。", // TODO 검수
    "payment.createError": "お支払いの準備ができませんでした。もう一度お試しください。", // TODO 검수
    "payment.expired": "お支払いの時間が過ぎました。もう一度お進みください。", // TODO 검수
    "payment.closed": "お支払いがキャンセルされました。もう一度お進みください。", // TODO 검수
    "printShare.title": "写真をお持ち帰りください",
    "printShare.kicker": "SCAN TO SAVE",
    "printShare.qrHeading": "スマホに保存",
    "printShare.desc1": "QRを読み取ると保存されます",
    "printShare.desc2": "リンクは{days}日間有効です",
    "printShare.privacy": "撮影原本は変換直後に削除 · 生成写真は{days}日後に削除",
    "printShare.printCta": "印刷する",
    "printShare.retake": "撮り直す",
    "printShare.home": "最初に戻る",
    "printShare.doneCta": "完了", // TODO 검수
    "printShare.shareHint": "「印刷する」を押した後、共有メニューから「プリント」を選んでください", // TODO 검수
    "printShare.bodyWithVideo": "QRを読み取ると写真と動画を一緒に受け取れます。", // TODO 검수
    "printShare.bodyVideoPending": "写真は今すぐ、動画は約2分後に\n同じリンクに表示されます", // TODO 검수
    "printShare.bodyVideoFailed": "動画を作成できませんでした。\n写真はそのまま受け取れます。", // TODO 검수
    "printShare.videoPendingLabel": "制作中", // TODO 검수
    "printShare.photoLabel": "写真", // TODO 검수
    "printShare.videoLabel": "動画", // TODO 검수
    "printShare.uploading": "アップロード", // TODO 검수
    "printShare.uploadError": "アップロードに失敗しました。もう一度お試しください。", // TODO 검수
    "printShare.retry": "もう一度試す", // TODO 검수
    "printShare.qrAlt": "写真受け取りページのQRコード", // TODO 검수
    "printShare.agentOffline": "プリンターの接続を確認しています。印刷が遅れる場合があります", // TODO 검수
    "thanks.title": "ありがとうございました", // TODO 검수
    "thanks.body": "素敵に残しました · {sec}秒後に最初の画面に戻ります", // TODO 검수
    "thanks.tapHint": "画面をタッチするとすぐに戻ります", // TODO 검수
    "lock.title": "現在ご利用いただけません", // TODO 검수
    "lock.body": "Currently Unavailable",
    "print.title": "印刷中です",
    "print.sub": "写真をお忘れなく",
    "print.status": "PRINTING · 1 / 1 · 約18秒",
    "print.preparing": "印刷の準備中です", // TODO 검수
    "print.delayed": "印刷に時間がかかっています。\nスタッフをお呼びください", // TODO 검수
    "print.delayedHint": "写真はQRコードから受け取れます", // TODO 검수
    "print.failed": "印刷に失敗しました。\nスタッフをお呼びください", // TODO 검수
    "print.paperOut": "用紙がありません。\nスタッフをお呼びください", // TODO 검수
};
//# sourceMappingURL=ja.js.map